/** Selector de idioma ES | EN, visible en el encabezado junto al botón de tema. */
import { useLang } from '../../context/LangContext';
import { t } from '../../i18n/dictionary';

export default function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="seg" role="group" aria-label={t('shell.language', lang)}>
      <button onClick={() => setLang('es')} aria-pressed={lang === 'es'} lang="es">ES</button>
      <button onClick={() => setLang('en')} aria-pressed={lang === 'en'} lang="en">EN</button>
    </div>
  );
}
